import { AfterViewInit, Component, OnDestroy, Input, OnChanges, SimpleChanges } from '@angular/core';
import { NbThemeService } from '@nebular/theme';
import { ResizedEvent } from 'angular-resize-event';
import { DEFAULT_THEME as defaultTheme } from '@nebular/theme';
import { Social_Platform,
  Material_Design_Red, 
  Material_Design_Pink, 
  Material_Design_Purple, 
  Material_Design_Deep_Purple,
  Material_Design_Lime,
  Material_Design_Deep_Purple_Seq,
  Classic_20} from '../config/color-palettes';

@Component({
  selector: 'nbx-barchart',
  templateUrl: './barchart.component.html',
  styleUrls: ['./barchart.component.scss']
})
export class BarEchartComponent implements AfterViewInit, OnChanges {
  @Input() resizable: boolean = true;
  autoResize = true;

  defaultThemeVariables = defaultTheme.variables;
  @Input() tooltipstr: string = '';
  @Input() legendstr: string = '';
  @Input() seriesstr: string = '';
  @Input() titlestr: string = '';
  @Input() gridstr: string = '';
  @Input() xaxisstr: string = '';
  @Input() yaxisstr: string = '';

  options: any = {};
  title: any;
  tooltip: any;
  legend: any;
  series: any;
  grid: any;
  xaxis: any;
  yaxis: any;

  width: number;
  height: number;

  echartsInstance: any;

  onResized(event: ResizedEvent) {
    this.width = event.newWidth;
    this.height = event.newHeight;

    if (this.echartsInstance)
    {
      this.echartsInstance.resize({
        height: event.newHeight
      });
    }
  }

  constructor(private theme: NbThemeService) {
  }

  ngAfterViewInit() {
    this.tooltip= (this.tooltipstr == '') ?  {
      trigger: 'axis',
      axisPointer: {
        type: 'cross',
        label: {
          color: this.defaultThemeVariables.fgText,
          backgroundColor: this.defaultThemeVariables.tooltipBackgroundColor,
        },
      },
    } : JSON.parse(this.tooltipstr);

    this.legend = (this.legendstr == '') ? {
      orient: "horizontal", 
      data: ['Mail marketing', 'Affiliate advertising', 'Video ad', 'Direct interview', 'Search engine', 'Data'],
      textStyle: {
        color: this.defaultThemeVariables.fgText,
      },
    } : JSON.parse(this.legendstr);

    this.grid = (this.gridstr == '') ? {
      left: '3%',
      right: '4%',
      bottom: '3%',
      containLabel: true,
    } : JSON.parse(this.gridstr);

    this.xaxis = (this.xaxisstr == '') ? {
      type: 'category',
      data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
    } : JSON.parse(this.xaxisstr);

    this.yaxis = (this.yaxisstr == '') ? {
      type: 'value'
  } : JSON.parse(this.yaxisstr);

    this.series = (this.seriesstr == '') ? [{
      data: [120, 200, 150, 80, 70, 110, 130],
      type: 'bar'
  }] : JSON.parse(this.seriesstr);


      this.options = {
        backgroundColor: 'transparent',
        color: Object.values(Classic_20),
        xAxis: this.xaxis,
        yAxis: this.yaxis,
        series: this.series,
        grid: this.grid,
        legend: this.legend,
        tooltip: this.tooltip
      };
  }

  ngOnChanges(changes: SimpleChanges) {
    for (const propName in changes)
    {
      if (changes.hasOwnProperty(propName))
      {
        switch(propName) {
          case 'tooltipstr': {
            console.log("tooltip update");
              this.updateOptions('tooltip',this.tooltipstr);
            break;     
          }
          case 'legendstr': {
            console.log("legend update");
              this.updateOptions('legend',this.legendstr);
            break;
          }
          case 'seriesstr': {
            console.log("series update");
              this.updateOptions('series',this.seriesstr);
            break;
          }
          case 'titlestr': {
            console.log("title update");
              this.updateOptions('title',this.titlestr);
            break;
          }
          case 'gridstr': {
            console.log("grid update");
              this.updateOptions('grid',this.gridstr);
            break;
          }
          case 'xaxisstr': {
            console.log("xaxis update");
              this.updateOptions('xaxis',this.xaxisstr);
            break;
          }
          case 'yaxisstr': {
            console.log("yaxis update");
              this.updateOptions('yaxis',this.yaxisstr);
            break;
          }
        }
      }
    }

    this.options = {
      backgroundColor: 'transparent',
      color: Object.values(Classic_20),
      title: this.title,
      tooltip: this.tooltip,
      legend: this.legend,
      grid: this.grid,
      xAxis: this.xaxis,
      yAxis: this.yaxis,
      series: this.series
    }

  }
    onChartInit(e: any) {
      this.echartsInstance = e;
      console.log('on chart init:', e);
    }

    private updateOptions(opt, value) {
      console.log(opt)
      console.log(value)
      this[opt] = JSON.parse(value);
      console.log(this[opt]);

      this.options[opt] = this[opt];

      console.log(this.options);  
    }

}